module.exports = __webpack_public_path__ + "img/img15.bc1a30ef.png";